import IconButton from '@mui/material/IconButton';
import Delete from '@mui/icons-material/Delete';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';
import ConfirmationModal from '~/components/ConfirmationModal';
import { useDeleteCircuit } from '~/hooks/api/useDeleteCircuit';
import messages from './messages';

type CircuitDeleteProps = {
  circuitId: number;
};

const CircuitDelete = (props: CircuitDeleteProps) => {
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();
  const [shouldShowConfirmationDialog, setConfirmationDialogVisibility] =
    useState(false);
  const mutation = useDeleteCircuit({
    onSuccess() {
      showSnackbar({
        message: intl.formatMessage(messages.deleteSuccess),
      });
      setConfirmationDialogVisibility(false);
    },
    onError() {
      setConfirmationDialogVisibility(false);
      showSnackbar({
        message: intl.formatMessage(messages.deleteFailure),
      });
    },
  });
  return (
    <>
      <IconButton
        color="inherit"
        onClick={() => setConfirmationDialogVisibility(true)}
        size="large"
      >
        <Delete data-testid="delete" />
      </IconButton>
      <ConfirmationModal
        open={shouldShowConfirmationDialog}
        title={intl.formatMessage(messages.deleteConfirmTitle)}
        text={<FormattedMessage {...messages.deleteConfirmText} />}
        confirmLabel={<FormattedMessage {...messages.deleteConfirmDelete} />}
        cancelLabel={<FormattedMessage {...messages.deleteConfirmCancel} />}
        onCancel={() => setConfirmationDialogVisibility(false)}
        onConfirm={() => mutation.mutate(props.circuitId)}
      />
    </>
  );
};

export default CircuitDelete;
